<template>
    <h1>{{ $t('menu.storeLocator.subpages.editStore.header') }}</h1>

    <div>
        <button class="appButton mt-2" @click="this.$router.push('/store-locator')">{{ $t('menu.storeLocator.subpages.editStore.back') }}</button>
        <button class="appButton mt-2" @click="deleteStore()">{{ $t('menu.storeLocator.subpages.editStore.delete') }}</button>
        <button class="appButton mt-2" @click="updateGeolocation()">{{ $t('menu.storeLocator.subpages.editStore.getGeoLocation') }}</button>    
        <button class="appButton mt-2" @click="saveStore()">{{ $t('menu.storeLocator.subpages.editStore.save') }}</button>
    </div>

    <div class="flex flex-row">
        <div class="w-1/4">
            <div class="pt-4 pb-4">
                <label for="name">{{ $t('menu.storeLocator.subpages.editStore.name') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.editStore.name">
            </div>

            <div class="pt-4 pb-4">
                <label for="address_line_1">{{ $t('menu.storeLocator.subpages.editStore.addressline1') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.editStore.address_line_1">
            </div>

            <div class="pt-4 pb-4">
                <label for="address_line_2">{{ $t('menu.storeLocator.subpages.editStore.addressline2') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.editStore.address_line_2">
            </div>

            <div class="pt-4 pb-4">
                <label for="postal_code">{{ $t('menu.storeLocator.subpages.editStore.postal_code') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.editStore.postal_code">
            </div>

            <div class="pt-4 pb-4">
                <label for="city">{{ $t('menu.storeLocator.subpages.editStore.state') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.editStore.state_province">
            </div>

            <div class="pt-4 pb-4">
                <label for="city">{{ $t('menu.storeLocator.subpages.editStore.city') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.editStore.city">
            </div>

            <div class="pt-4 pb-4">
                <label for="country">{{ $t('menu.storeLocator.subpages.editStore.country') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.editStore.country">
            </div>

        </div>
        <div class="w-1/4">
            <div class="pt-4 pb-4">
                <label for="phone">{{ $t('menu.storeLocator.subpages.editStore.phone') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.editStore.phone">
            </div>

            <div class="pt-4 pb-4">
                <label for="email">{{ $t('menu.storeLocator.subpages.editStore.email') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.editStore.email">
            </div>

            <div class="pt-4 pb-4">
                <label for="website">{{ $t('menu.storeLocator.subpages.editStore.website') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.editStore.website">
            </div>

            <div class="pt-4 pb-4">
                <label for="retail_support_program">{{ $t('menu.storeLocator.subpages.editStore.retail_support_program')
                }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.editStore.retail_support_program">
            </div>

          <div class="pt-4 pb-4">
                <label for="retail_support_program">{{ $t('menu.storeLocator.subpages.editStore.ranges')
                }}</label><br />
                <ul class="list-disc pl-5" v-show="user.editStore.ranges">
                    <li v-for="(range, index) in user.editStore.ranges.split(',')" :key="index">
                        {{ range.trim() }}
                    </li>
                </ul>
                <div v-show="!user.editStore.ranges">{{ $t('menu.storeLocator.subpages.editStore.noRanges') }}</div>
                <!-- <input class="p-2 w-64" type="text" v-model="user.editStore.ranges"> -->
            </div>
        </div>
        <div class="w-1/4">
            <div class="pt-4 pb-4">
                <label for="status_p_id">{{ $t('menu.storeLocator.subpages.editStore.status_id') }}</label><br />
                <select class="p-2 w-64" v-model="user.editStore.status_p_id">
                    <option v-for="status in user.storeStatus" :key="status.p_id" :value="status.p_id">
                        {{ status.name }}
                    </option>
                </select>
            </div>

            <div class="pt-4 pb-4">
                <label for="type_p_id">{{ $t('menu.storeLocator.subpages.editStore.type_id') }}</label><br />
                <select class="p-2 w-64" v-model="user.editStore.type_p_id">
                    <option v-for="type in user.storeTypes" :key="type.p_id" :value="type.p_id">
                        {{ type.name }}
                    </option>
                </select>
            </div>

            <div class="pt-4 pb-4">
                <label for="lat">{{ $t('menu.storeLocator.subpages.editStore.latitude') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.editStore.lat">
            </div>

            <div class="pt-4 pb-4">
                <label for="lon">{{ $t('menu.storeLocator.subpages.editStore.longitude') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.editStore.lon">
            </div>

            <div class="pt-4 pb-4">
                <label for="lon">{{ $t('menu.storeLocator.subpages.editStore.businessStatus') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.editStore.businessStatus">
            </div>
        </div>
        <div class="w-1/4 pl-4 rounded-md" style="background: #1a2028; border: 1px solid rgba(255,255,255,0.06);">
            <div class="pt-4 pb-4">
                <label for="internal_contact_person">{{ $t('menu.storeLocator.subpages.editStore.internal_contact_person')
                }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.editStore.internal_contact_person">
            </div>

            <div class="pt-4 pb-4">
                <label for="internal_notes">{{ $t('menu.storeLocator.subpages.editStore.internal_notes') }}</label><br />
                <textarea class="p-2 w-64 h-64" v-model="user.editStore.internal_notes"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
import { useSettings } from '@/store/user'
import mixins from '@/components/mixins';

export default {
    mixins: [mixins],
    setup() {
        const user = useSettings();

        user.getStoreTypes();
        user.getStoreStatus();

        return { user }
    },
    data() {
        return {

        }
    },
    components: {

    },
    methods: {
        async saveStore() {
            this.user.saveStore(this.user.editStore).then(() => {
                this.$router.push('/store-locator');
            });
        },
        async deleteStore() {
            if (confirm(this.$t('menu.storeLocator.subpages.editStore.deleteConfirm'))) {
                this.user.deleteStore(this.user.editStore.p_id).then(() => {
                    this.$router.push('/store-locator');
                });
            }
        },
        async updateGeolocation() {
            this.user.updateGeolocation().then(() => {
                // loop through this.user.editStore and make sure that all strings are trimmed and only the first letter is capitalized and the rest is lowercase
                for (const key in this.user.editStore) {
                    if (typeof this.user.editStore[key] === "string" && (key == 'name' || key == 'address_line_1' || key == 'address_line_2' || key == 'city' || key == 'state_province')) {
                        this.user.editStore[key] = this.user.editStore[key].trim();
                        this.user.editStore[key] = this.user.editStore[key].replace(/\b\w/g, char => char.toUpperCase());
                    }
                }
            }).catch((error) => {
                console.error(error);
                alert(this.$t('menu.storeLocator.subpages.editStore.geoLocationError'));
            });
        }
    }
}
</script>